import { render } from "./Standards.vue?vue&type=template&id=eb70ca74"
import script from "./Standards.vue?vue&type=script&lang=js"
export * from "./Standards.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__